export default "__VITE_ASSET__CBE_mwBD__"